var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-2 px-7 mb-3 text-no-wrap rounded-pill grey lighten-4 d-flex justify-space-between align-center",style:({ width: _vm.width, border: _vm.border })},[_c('span',{staticClass:"grey--text text--darken-1 text-sm-body-1",class:[
      _vm.bigText ? 'text-lg-h5' : 'text-lg-h6',
      _vm.textCenter ? 'w-100 text-center' : '',
      { 'font-weight-bold': _vm.bold }
    ]},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }